import App from "./app";

export default class ApnsApp extends App {
    #_pushId: String;
    #_webServiceUrl: String;

    constructor(params = {}) {
        super(params);
        const { apns } = params;
        this.#_pushId = apns.pushId;
        this.#_webServiceUrl = apns.webServiceUrl;
    }

    getPushId() {
        return this.#_pushId;
    }

    getWebServiceURL() {
        return this.#_webServiceUrl;
    }

    validate() {
        super.validate();

        if (!this.#_pushId) {
            throw new Error("pushId must be set");
        }
        if (!this.#_webServiceUrl) {
            throw new Error("webServiceUrl must be set");
        }
    }
}
